import { Map } from "@/shared/components/control";
import { Section } from "@/shared/components/ui";
import { useTranslation } from "react-i18next";

export function Provocative() {
  const { t } = useTranslation();
  const paragraphs = t("home.provocative.paragraphs", { returnObjects: true }) as string[];
  return (
    <Section narrow className="border-b border-border-soft">
      <h2 className="font-display text-[calc(1.65rem+0.85vw)] font-semibold leading-tight tracking-tight text-ink">
        {t("home.provocative.title")}
      </h2>
      <div className="mt-8 space-y-6 text-pretty text-[calc(0.95rem+0.12vw)] font-normal leading-relaxed text-ink-secondary">
        <Map
          items={paragraphs}
          keyExtractor={(p, i) => `provocative-${i}`}
          render={p => <p className="whitespace-pre-line">{p}</p>}
        />
      </div>
    </Section>
  );
}
